<template>
  <el-collapse
    id="pickerSection"
    style="width:99.9%"
    class="section relative-view"
    v-model="activeNames"
  >
    <el-checkbox
      v-if="isShowPickerAll"
      class="section-checkboxAll"
      v-model="selectPickerAll"
      @change="onChangeSelectPickerAll"
    >
      <span class="c-9 f-12">全选</span>
    </el-checkbox>
    <div v-for="(item, i) in list" :key="i">
      <el-collapse-item :name="i" class="pick-item relative-view">
        <template slot="title">
          <PickerSectionTitle :item="item" v-bind="$attrs"></PickerSectionTitle>
          <el-checkbox
            v-if="isShowPickerAll"
            class="section-checkbox"
            v-model="item.selected"
            @change="onChangeSelectPicker(item)"
          ></el-checkbox>
        </template>
        <el-table :data="setTabelData(item.orderItems, item)" class="c-3 f-13">
          <el-table-column label="商品" align="center" header-align="center" width="250">
            <template v-slot="scope">
              <div>{{ scope.row.name }}</div>
              <div v-if="scope.row.supplierName" class="f-12 c-9 m-t10">
                {{ scope.row.supplierName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="商品属性" header-align="center">
            <template v-slot="scope">
              <ul class="m-l32">
                <li>{{ scope.row.desc }}</li>
                <li>计量方式：{{ scope.row.type }}</li>
                <li>{{ scope.row.perWeight }}</li>
                <li>计价单位：{{ scope.row.weightUnitValue | exUnitToBaseUnit }}</li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="perPrice" label="单价" align="center">
            <template slot-scope="scope">
              <span class="c-red">{{ scope.row.perPrice }}</span>
              <zg-info
                v-if="
                  scope.row.logisticsPrice ||
                    scope.row.processFee ||
                    scope.row.storageFee ||
                    scope.row.commissionFee ||
                    scope.row.promiseInterestSubsidyFee ||
                    scope.row.settleAdjustFee
                "
              >
                <div slot="content">
                  <div v-if="scope.row.logisticsPrice">
                    胖猫物流费：{{ scope.row.logisticsPrice }}
                  </div>
                  <div v-if="scope.row.processFee">加工费：{{ scope.row.processFee }}</div>
                  <div v-if="scope.row.storageFee">仓储费：{{ scope.row.storageFee }}</div>
                  <div v-if="scope.row.commissionFee">
                    委托物流费：{{ scope.row.commissionFee }}
                  </div>
                  <div v-if="scope.row.promiseInterestSubsidyFee">
                    承兑贴息费：{{ scope.row.promiseInterestSubsidyFee }}
                  </div>
                  <div v-if="scope.row.settleAdjustFee">
                    结算调差费：{{ scope.row.settleAdjustFee }}
                  </div>
                </div>
              </zg-info>
            </template>
          </el-table-column>
          <el-table-column prop="pre" label="预提数量/重量" align="center"></el-table-column>
          <el-table-column prop="real" label="实提数量/重量" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.real }}</span>
              <zg-info
                v-if="PickerStatusStr[item.status] !== '待发货' && Number(scope.row.realNum) === 0"
                class="m-l5"
              >
                <div slot="content">该商品未提货, 已返回待提列表。</div>
              </zg-info>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <div class="total f-14 f-b p-lr20 flex-h-ac flex-e">
        <div class="c-3 m-r30">
          总计&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="c-9"
            >预提：{{ item.preProductNum }} /
            <span class="c-red">{{ item.preProductWeight | formatWeight }}</span> 吨</span
          >&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="c-9"
            >实提：{{ item.realProductNum }} /
            <span class="c-red">{{ item.realProductWeight | formatWeight }}</span> 吨</span
          >&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <el-button
          v-if="
            PickerStatusStr[item.status] === '待发货' && item.logisticsWay === PickerTypeCode.SELLER
          "
          size="medium"
          @click="cancelPicker(item)"
          >取消提货</el-button
        >
        <el-button
          v-if="
            PickerStatusStr[item.status] === '待发货' && item.logisticsWay === PickerTypeCode.SELLER
          "
          size="medium"
          @click="editPickerInfo(item)"
          >编辑提货人信息</el-button
        >
        <el-button
          size="medium"
          v-if="PickerStatusStr[item.status] === '待发货' && item.refuseStatus === 1"
          @click="buyerPickerCancel(item)"
          >{{ '同意取消发货' }}</el-button
        >
        <el-button size="medium" type="primary" @click="showPickerDialog(item)">
          {{ item.status >= 3 ? '查看发货凭证' : '上传发货凭证' }}
        </el-button>
        <el-button
          size="medium"
          v-if="
            PickerStatusStr[item.status] === '待发货' || PickerStatusStr[item.status] === '待收货'
          "
          type="primary"
          @click="toPickerChange(item)"
          >{{ PickerStatusStr[item.status] === '待收货' ? '修改发货信息' : '填写实提' }}</el-button
        >
        <el-button
          size="medium"
          v-if="PickerStatusStr[item.status] === '待发货' && item.isOnline === 1"
          type="primary"
          @click="toPickerChange(item, true)"
        >
          通知仓库发货
        </el-button>
      </div>
    </div>
    <picker-section-dialog
      ref="PickerSectionDialog"
      :getData="getData"
      :pickerId="pickerId"
      :pickerInfo="pickerInfo"
    ></picker-section-dialog>
    <RefuseDialog ref="RefuseDialog" @submit="onClickDialogSubmit"></RefuseDialog>
    <upload-picker-dialog
      ref="viewPickerDialog"
      @confirm="saveUploadFiles"
      :show-option="isShowOption"
    ></upload-picker-dialog>
  </el-collapse>
</template>

<script>
import { PickerTypeCode, PickerStatusStr } from '../code'
import PickerSectionTitle from './picker-section-title'
import PickerSectionDialog from './picker-section-dialog'
import RefuseDialog from '../../../components/refuseDialog/refuse-dialog'
import ZgInfo from '@/components/zg-info'
import { formatWeight, exUnit } from '@/common/filters/index.js'
import UploadPickerDialog from './uploadPickerDialog'

export default {
  name: 'PickerSection',
  components: {
    PickerSectionTitle,
    PickerSectionDialog,
    RefuseDialog,
    ZgInfo,
    UploadPickerDialog
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    getData: Function,
    isShowPickerAll: Boolean
  },
  filters: {
    splitColon(text) {
      return text.split(':')
    }
  },
  data() {
    return {
      PickerStatusStr,
      PickerTypeCode,
      activeNames: null, // collapse -> [0] (手风琴模式)
      pickerId: 0,
      pickerInfo: {}, // 提货人信息集合
      selectPickerAll: false, // 是否全选
      currentItem: null, // 当前选中的提货函
      currentUploadItem: null,
      isShowOption: false
    }
  },
  created() {
    this.list.forEach(item => {
      item.isChecked = true
    })
  },
  methods: {
    setTabelData(cells, item) {
      let tableList = []
      cells.forEach(cell => {
        let {
          productTitle,
          productSubTitle,
          bundleNo,
          productPrice,
          weightUnitValue,
          valuationWay,
          perProductWeight,
          preProductNum,
          preProductWeight,
          realProductNum,
          realProductWeight,
          supplierName,
          logisticsPrice,
          processFee,
          storageFee,
          commissionFee,
          promiseInterestSubsidyFee,
          settleAdjustFee
        } = cell
        let tableData = {
          weightUnitValue: weightUnitValue,
          name: productTitle,
          supplierName: supplierName,
          desc:
            typeof bundleNo === 'undefined' || bundleNo === '' || bundleNo === null
              ? ''
              : `捆包号：${bundleNo}`,
          type: typeof valuationWay !== 'undefined' ? `${valuationWay}` : '',
          perWeight: `单件重：${formatWeight(perProductWeight)} 吨`,
          perPrice: `¥ ${productPrice}`,
          pre: `${preProductNum}${exUnit(weightUnitValue)} / ${formatWeight(preProductWeight)}吨`,
          real: `${realProductNum}${exUnit(weightUnitValue)} / ${formatWeight(
            realProductWeight
          )}吨`,
          preNum: preProductNum,
          preWeight: formatWeight(preProductWeight),
          realNum: realProductNum === 0 ? 0 : realProductNum,
          realWeight: formatWeight(realProductWeight) == 0 ? 0 : formatWeight(realProductWeight),
          logisticsPrice,
          processFee,
          storageFee,
          commissionFee,
          promiseInterestSubsidyFee,
          settleAdjustFee
        }
        // 这里处理一下抄码情况, 列表展示的数据, 仅未实提过, 且为抄码的商品, 设置初始值
        // if (item.statusStr === '待发货' && (valuationWay === '抄码' || valuationWay === '理计')) {
        // 表格展示的实提数据 = 格式化后的预提数据
        // tableData.realNum =  preProductNum
        // tableData.realWeight = formatWeight(preProductWeight)
        // }
        tableList.push((cell.tableData = tableData))
      })
      return tableList
    },
    // 买家取消提单逻辑
    buyerPickerCancel(item) {
      const h = this.$createElement
      this.$msgbox({
        title: '买家申请取消提单',
        message: h('div', null, [
          // h('p', null,  `申请时间： ${'~~~~~~~'}`),
          // h('p', null, `申请人：${'~~~~~'}`),
          h('p', null, `申请取消原因：${item.refuseReason}`)
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(action => {
          this.pickerCancel(item)
        })
        .catch(() => {})
    },
    async pickerCancel(item) {
      let { success, data } = await this.$post('lgcenter.cancelDispatchOrder', {
        cancelDispatchOrder: {
          dispatchOrderId: item.id
        }
      })
      console.log('~~~~lgcenter.cancelDispatchOrder~~~~~', data)
      data = data[0]
      if (success && data.success) {
        this.$message.success('提单取消成功')
        this.$router.go(0) // 强制刷新当前页
      } else {
        this.$message.error(data.message)
      }
    },
    // 商家配送取消提单逻辑
    cancelPicker(item) {
      this.currentItem = item
      this.$refs.RefuseDialog.showDialog(true, 'cancelPicker')
    },
    onClickDialogSubmit(select) {
      this.submitCancelPicker(select)
    },
    async submitCancelPicker(select) {
      const { success, data } = await this.$post('lgcenter.cancelDispatchOrderSeller', {
        cancelDispatchOrder: { dispatchOrderId: this.currentItem.id, refuseReason: select.label }
      })
      if (success) {
        this.$message.success('提单已取消')
        this.getData()
      } else {
        this.$message.error(data[0].message)
      }
    },
    // 编辑商家配送提货人信息
    editPickerInfo(item) {
      let {
        id,
        dispatcherName,
        dispatcherContact,
        dispatcherCarNo,
        dispatcherCardNo,
        dispatcherParam
      } = item.dispatcherInfoDTO
      this.pickerId = item.id
      this.pickerInfo = {
        dispatcherName,
        dispatcherContact,
        dispatcherCarNo,
        dispatcherCardNo,
        dispatcherParam
      }
      this.$refs.PickerSectionDialog.isShowInfoDialog = true
    },
    // 批量发货逻辑
    onChangeSelectPickerAll(v) {
      this.list.forEach(item => {
        item.selected = this.selectPickerAll
      })
      this.$store.commit('setPickerSelectArray', this.selectPickerAll ? this.list : [])
    },
    onChangeSelectPicker(v) {
      // 更新全选按钮
      this.selectPickerAll = this.list.every(item => {
        return item.selected === true
      })
      // 存储选中数据
      let selectArr = []
      this.list.forEach(item => {
        if (item.selected) selectArr.push(item)
      })
      this.$store.commit('setPickerSelectArray', selectArr)
    },
    toPickerChange(item, toNotifyPage) {
      // 因为通过接口拉取新值, 故不再预先设置实提数量
      // 这里处理下抄码情况的实提, 因为下一个页面如果没输入过, 就不会赋值, 所以提前赋值
      // item.orderItems.forEach(cell => {
      //   if (cell.valuationWay === '抄码' && cell.realProductNum === 0) {
      //     // 实提数据=预提数据
      //     cell.realProductNum = cell.preProductNum
      //     cell.realProductWeight = cell.preProductWeight
      //   }
      // });
      // this.$router.push({name: 'picker-change', params: {item}})
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      let list = []
      item.orderItems.forEach(cell => {
        let obj = {}
        obj.dispatchOrderId = cell.dispatchOrderId
        obj.outId = cell.outId
        // obj.dispatchOrderItemId = cell.id // 替换为上面
        if (cell.realProductNum === 0) {
          // 未实提过
          if (
            cell.valuationWay === '抄码' ||
            (cell.valuationWay === '理计' && this.PickerStatusStr[item.status] === '待发货')
          ) {
            // 实提数据=预提数据
            obj.realProductNum = cell.preProductNum
            obj.realProductWeight = cell.preProductWeight
          } else {
            obj.realProductNum = 0
            obj.realProductWeight = '0'
          }
        } else {
          // 实提过
          obj.realProductNum = cell.realProductNum
          obj.realProductWeight = cell.realProductWeight
        }
        list.push(obj)
      })
      let url = !toNotifyPage ? 'picker-change' : 'picker-notify'
      this.$router.push({ name: url, query: { list: encodeURIComponent(JSON.stringify(list)) } })
    },
    async showPickerDialog(item) {
      const { success, data = [] } = await this.$get('lgcenter.queryCertificateList', {
        params: {
          dispatchOrderNo: item.dispatchOrderNo,
          pageSize: 1000
        }
      })
      if (success) {
        const list = (data.pop() || {}).data || []
        list.forEach(item =>
          this.$refs.viewPickerDialog.uploadChange({
            id: item.id,
            fk: item.fileKey,
            name: item.fileName
          })
        )
      }
      this.isShowOption = item.status <= 2
      this.currentUploadItem = item
      this.$refs.viewPickerDialog.visible = true
      this.$refs.viewPickerDialog.setEextraParam(item)
    },
    async saveUploadFiles({ fileList }) {
      const { success } = await this.$get('lgcenter.uploadCertificate', {
        params: {
          dispatchOrderNo: this.currentUploadItem.dispatchOrderNo,
          uploadParamList: fileList
        }
      })
      if (success) {
        this.$message.success('上传成功！')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
#pickerSection /deep/ .el-collapse-item__header {
  height: 100%;
  border: 0px;
}
#pickerSection /deep/ .el-collapse-item__wrap {
  border: 0px;
  transition: 0ms;
}
#pickerSection /deep/ .el-collapse-item__arrow {
  display: none;
}
#pickerSection /deep/ .el-collapse-item {
  padding: 20px 0 0 0;
}
#pickerSection /deep/ .el-collapse  {
  border: 0px;
}
// 弹窗
#pickerSection /deep/ .el-dialog__body {
  padding: 20px;
}
#pickerSection /deep/ .el-input__inner {
  // text-align: center;
}

// 表格
#pickerSection /deep/ .el-collapse-item__content {
  padding-bottom: 0;
}

#pickerSection
  & >>> .el-table
    border-top 1px solid #f0f0f0
    border-bottom 1px solid #f0f0f0
    &::before
      display none
    & th.is-leaf, & td
      border none
    & th.is-leaf
      background #F8F8F8
      font-size 12px
      color #999999
    & td
      vertical-align unset
</style>

<style lang="less" scoped>
.section {
  .section-checkboxAll {
    min-width: 65px;
    position: absolute;
    top: -41px;
    left: 15px;
  }
  .section-checkbox {
    position: absolute;
    top: 22px;
    left: 15px;
  }
  .total {
    height: 60px;
    border-top: 1px solid white;
  }
  border: unset;
}
</style>
